import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e55d1178"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "zs_title" }, "政府采购从业人员培训证书查询", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "zs_tip" }, "培训咨询电话：010-88587089", -1))
const _hoisted_4 = { class: "btn_wrap" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询")

import { ElForm, ElMessageBox } from "element-plus";
import { onMounted, ref } from "vue";
import { reactive } from "vue-demi";
import { useRouter,useRoute } from "vue-router";
import * as zsApi from "@/api/zs";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const formRef = ref<InstanceType<typeof ElForm>>();

const ZsQuery = (formEl: InstanceType<typeof ElForm> | undefined) => {
  console.log(formEl);
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      asyncZsData(zsForm.ids);
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

/**
 * @description: 请求证书列表
 * @param {
 *  pageNum：分页器页码
 * }
 * @return {*}
 */
const asyncZsData = async (ident) => {
  const params = {
    ident: ident,
    pageNum: 1,
    pageSize: 5,
  };
  const res = await zsApi.getByIdent(params);
  console.log(res);

  if (res.resCode == 200) {
    if (res.resData.list.length == 0) {
      ElMessageBox.alert("该身份证下没有证书，请重新输入", "提示", {
        confirmButtonText: "重新输入",
        callback: () => {
          console.log(123);
          router.push({
              path: "/",
              query: {
                ident: route.query.ident
              }
            });
        },
      });
    } else {
      router.push({
        path: "/zs_list",
        query: {
          ident: zsForm.ids,
        },
      });
    }
  }
};

const zsForm = reactive({
  ids: route.query.ident ? route.query.ident : '',
});

const identRules = (rule, value, callback) => {
  if (!checkCertificateNo(value)) {
    callback(new Error("请输入正确的身份证号"));
  } else {
    callback();
  }
};

const checkCertificateNo = (val) => {
  var certificateNo = val; //身份证号码
  if (certificateNo.length != 18) {
    return 0;
  } else {
    var address = certificateNo.substring(0, 6); //6位，地区代码
    var birthday = certificateNo.substring(6, 14); //8位，出生日期
    var sequenceCode = certificateNo.substring(14, 17); //3位，顺序码：奇为男，偶为女
    var checkCode = certificateNo.substring(17); //1位，校验码：检验位
    var province = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外",
    };

    var year = birthday.substring(0, 4);
    var month = birthday.substring(4, 6);
    var day = birthday.substring(6);
    var tempDate = new Date(year, parseFloat(month) - 1, parseFloat(day));
    if (
      province[parseInt(address.substr(0, 2))] == null ||
      tempDate.getFullYear() != parseFloat(year) ||
      tempDate.getMonth() != parseFloat(month) - 1 ||
      tempDate.getDate() != parseFloat(day)
    ) {
      //这里用getFullYear()获取年份，避免千年虫问题
      return 0;
    } else {
      var weightedFactors = [
        7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1,
      ]; //加权因子
      var valideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值，当中10代表X
      var certificateNoArray = certificateNo.split(""); // 得到身份证数组
      var sum = 0; // 声明加权求和变量
      if (certificateNoArray[17].toLowerCase() == "x") {
        certificateNoArray[17] = 10; // 将最后位为x的验证码替换为10
      }
      for (var i = 0; i < 17; i++) {
        sum += weightedFactors[i] * certificateNoArray[i]; // 加权求和
      }
      let valCodePosition = sum % 11; // 得到验证码所在位置
      if (certificateNoArray[17] == valideCode[valCodePosition]) {
        var sex = "男";
        if (sequenceCode % 2 == 0) {
          sex = "女";
        }
        return 1;
      } else {
        return 0;
      }
    }
  }
};

const rules = reactive({
  ids: [
    { required: true, message: "请填写身份证号", trigger: "change" },
    { validator: identRules, trigger: "change" },
  ],
});

onMounted(() => {
  document.onkeydown = function (e) {
    //事件对象兼容
    let e1 = e || event || window.event || arguments.callee.caller.arguments[0];
    //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
    //左
    if (e1 && e1.keyCode == 13) {
      ZsQuery(formRef.value);
    }
  };
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 35 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_unref(ElForm), {
              ref_key: "formRef",
              ref: formRef,
              model: _unref(zsForm),
              "label-width": "120px",
              rules: _unref(rules),
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "身份证号",
                  prop: "ids"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(zsForm).ids,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(zsForm).ids) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (ZsQuery(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})